import ContactUsForm from "@/components/organisms/forms/contact-us-form";
import ContactJSONLD from "@/components/organisms/contact-jsonld";
import StageHeader from "@/components/organisms/stage-header";
import { getSingle } from "@/lib/prismic";
import { Content } from "@prismicio/client";
import { notFound } from "next/navigation";
import { use } from "react";

type ContactProps = {
  resolution: Resolution;
};

const Contact = ({ resolution }: ContactProps) => {
  const document = use(getSingle<Content.ContactDocument>("contact", resolution.locale));

  if (!document || !document.data) return notFound();

  return (
    <>
      <ContactJSONLD data={document.data} locale={resolution.locale} />
      <StageHeader
        locale={resolution.locale}
        className="md:my-4"
        orientationOnMobile="left"
        highlight
        title={document.data.title}
        description={document.data.text}
      />
      <section className="my-7.5 bg-[#FBF9F899] px-3.5 py-7.5 md:px-7.5 md:py-16">
        <ContactUsForm data={document.data} locale={resolution.locale} />
      </section>
    </>
  );
};

export default Contact;
